<template>
    <div class="start-new-imprint">
        <div class="start-new-imprint__section imprint-location">
            <label class="start-new-imprint__label" for="imprint-location">
                Imprint Location
            </label>
            <select
                id="imprint-location"
                class="start-new-imprint__selector form-control imprint-location"
                v-model="imprintLocationSelected"
                @change="setImprintLocation($event.target.value, $event)"
            >
                <option
                    v-for="option in imprintData.imprint_position._imprints"
                    :key="option.sku"
                    :value="option.title"
                    :data-sku="option.sku"
                    :ref="'imprint_location'+option.sku"
                >
                    {{ option.title }}
                </option>
            </select>
        </div>

        <div class="start-new-imprint__section imprint-type">
            <label class="start-new-imprint__label start-new-imprint__label-imprint-types" for="imprint-types">Imprint Type</label>
            <div id="imprint-types" class="start-new-imprint__tabs imprint-message__items">
                <template v-for="imprintType in imprintTypes" :key="imprintType.id">
                    <button
                        class="imprint-message__item imprint-message__item--btn"
                        @click="initTab(imprintType.id)"
                        :class="activeImprintTypeID == imprintType.id ? ['imprint-type__tab--active', customBackground] : ''"
                    >
                        {{ imprintType.label }}
                    </button>
                </template>
            </div>
        </div>

        <div v-if="activeImprintTypeID !==2" class="start-new-imprint__section imprint-type--message">
            <label class="start-new-imprint__label" for="imprint-type--message">
                {{ activeImprintTypeID === 3 ? "Step 1: Add your " : '' }}Imprint Message
            </label>
            <template v-for="(messageLine, index) in imprintMessageColorLines" :key="messageLine.id">
                <template v-if="messageLine.type === 'message' ">
                    <div id="imprint-type--message" class="start-new-imprint__tabs imprint-message__items">
                        <ul class="clist-table clist-table--titles clist-style--none">
                            <li class="clist-table__row clist-table__row--two-cols">
                                <div class="clist-table__col clist-table__col--title clist-table__col--title-double">
                                    <div>{{ getColorText()}}</div>
                                    <div class="applay-to-all_label" style="width: 50%;text-align: center;">
                                        <template v-if="index === 0">
                                            Apply to all
                                        </template>
                                    </div>
                                </div>

                                <div class="clist-table__col clist-table__col--title clist-table__col--title_line">
                                    <span>Line {{ index + 1 }}</span>
                                    <span
                                        v-if="isRemoveBtnShow(activeImprintTypeID, index, messageLine)"
                                        class="clist-table__text-remove"
                                        @click="deleteLineImprintMessage(index, messageLine)"
                                    >
                                        Remove
                                    </span>
                                </div>
                            </li>
                            <li class="clist-table__row clist-table__row--two-cols">
                                <div class="clist-table__col clist-table__col--double">
                                    <div
                                        :class="messageLine.custommColor ? 'selected_color_wrapper selected_color_wrapper--large' : 'selected_color_wrapper'"
                                        @click="colorsPantoneWrappToogle(index)"
                                    >
                                        <template v-if="!messageLine.custommColor">
                                            <div
                                                class="selected_color"
                                                :style="messageLine.selectedColor != null ? 'background-image:url(' + colorCatalogBaseUrl + messageLine.selectedColor + '.png)' : 'background:' + selectColorBtn.defaultBg"
                                            >
                                            </div>
                                        </template>

                                        <template v-if="messageLine.custommColor">
                                            <div
                                                class="selected_color custom"
                                            >
                                                {{ messageLine.selectedColor }}
                                            </div>
                                        </template>
                                    </div>
                                    <div class="applay-to-all-checkbox" style="width: 50%; text-align: center;">
                                        <!-- input type="checkbox" :value="messageLine.selectedColor" v-model="selectedApplaytoAll" -->
                                        <input
                                            :disabled="isCheckboxDisabled(index, messageLine.randID)"
                                            :checked="store.imprintStep.applyToAll.id !== null && store.imprintStep.applyToAll.randID !== messageLine.randID"
                                            type="checkbox"
                                            @input="applayToAllToogle(messageLine.id, messageLine.selectedColor, index, messageLine)"
                                        >
                                    </div>
                                </div>
                                <div class="clist-table__col clist-table__col--right-input">
                                    <input
                                        class="c-full-width new-imprint-input new-imprint-input--message"
                                        type="text"
                                        :value="messageLine.lineMessage"
                                        @change="setMessageForLine(index, $event.target.value)"
                                    >
                                </div>
                            </li>
                        </ul>

                    </div>
                    <div v-if="messageLine.selectedColor == 'cmyk'" class="cmyk-description">
                      <b>Full {{getColorText()}}</b>
                      <p> Your imprint will be completed in full {{getColorText(true)}}. A member of our team will contact you about
                        your design after your order.</p>
                    </div>
                    <!--
                        Check why here useing image type (c_color, index) in imprintColorsByLine[messageLine.id]
                    -->
                    <div class="choise-colors-pantone-wrapp" v-if="messageLine.isOpenedColorsPantoneWrapp">
                        <div class="choise-colors-section">
                            <template v-if="imprintColorsByLine[messageLine.id]">
                                <template v-for="(c_color, colorsindex) in imprintColorsByLine[messageLine.id]._colors" :key="colorsindex">
                                    <button
                                        class="choise-colors-section__item"
                                        style="width:25px; height: 25px"
                                        :style="'background-image:url(' + colorCatalogBaseUrl + c_color.file_name + '.png)'"
                                        @click="setColorForLine(index, c_color)"
                                    >

                                    </button>
                                </template>
                            </template>
                        </div>
                        <div class="text-or">
                            -OR-
                        </div>
                        <div class="applay-to-all">

                        </div>
                        <div class="pantone">
                            <template v-for="(customColor, colorIndex) in customColorList" :key="colorIndex">
                                <div class="custom-color-wrapp" @click="initCustomColorForLine(customColor, index)">
                                    {{ customColor }}
                                </div>
                            </template>
                            <input
                                :id="'pantone-input-' + messageLine.id"
                                :ref="'pantone-input-' + messageLine.id"
                                class="pantone-input"
                                type="text"
                                placeholder="Enter PANTONE© name"
                            >

                            <div class="pantone-input-sub-wrapp">
                                <div class="pantone-input-sub__price">{{ '$' + customColourFee.toFixed(2) }}</div>
                                <div class="pantone-input-sub__link-wrapp">
                                    <a
                                        class="pantone-input-sub__link"
                                        @click="pantoneSubmit(messageLine.id,'pantone-input-' + messageLine.id)"
                                    >
                                        submit
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </template>
            <div v-if="isActiveAddLine()" :class="['imprint-message__add', customColor]" @click="addLineImprintMessage">
                <span class="plus">+</span>
                <span>Add a New Line</span>
            </div>
            <div v-if="activeImprintTypeID === 3 && imprintMessageColorLines.length <= maxCountLines" :class="['imprint-message__add', customColor]" @click="addLineImprintMessage">
                <span class="plus">+</span>
                <span>Add a New Line</span>
            </div>
            <div v-if="activeImprintTypeID === 3">
              <p style="border-bottom: 1px solid #5A5A5A; margin: 0; padding-top: 8px"></p>
            </div>
        </div>



        <div v-if="activeImprintTypeID !== 1" class="start-new-imprint__section imprint-type--uploads">

            <!-- !!!!!!!!!!!!!!!!!!!!!!!!!!!!!  -->
                    <UploadImage @upload-changed="uploadChanged" :activeImprintTypeID = activeImprintTypeID></UploadImage>
            <!-- !!!!!!!!!!!!!!!!!!!!!!!!!!!!!  -->

    <!-- Start Image Color Line Section -->
    <template v-for="(messageLine, index) in imprintMessageColorLines" :key="messageLine.id">
        <template v-if="messageLine.type === 'image' ">
            <div id="imprint-type--message" class="start-new-imprint__tabs imprint-message__items">
                <ul class="clist-table clist-table--titles clist-style--none">
                    <li class="clist-table__row clist-table__row--two-cols">
                        <div class="clist-table__col clist-table__col--title clist-table__col--title-double">
                          <div class="image-color-text"> Image {{ getColorText() }}</div>
                        </div>

                        <div class="clist-table__col clist-table__col--title clist-table__col--title_line">

                        </div>
                    </li>
                    <li class="clist-table__row clist-table__row--two-cols">
                        <div class="clist-table__col clist-table__col--double">
                            <div
                                :class="messageLine.custommColor ? 'selected_color_wrapper selected_color_wrapper--large' : 'selected_color_wrapper'"
                                @click="colorsPantoneWrappToogle(index)"
                            >
                                <template v-if="!messageLine.custommColor">
                                    <div
                                        class="selected_color"
                                        :style="messageLine.selectedColor != null ? 'background-image:url(' + colorCatalogBaseUrl + messageLine.selectedColor + '.png)' : 'background:' + selectColorBtn.defaultBg"
                                    >
                                    </div>
                                </template>

                                <template v-if="messageLine.custommColor">
                                    <div
                                        class="selected_color"
                                    >
                                        {{ messageLine.selectedColor }}
                                    </div>
                                </template>
                            </div>
                            <div class="applay-to-all-checkbox" style="width: 50%; text-align: center; display: none">
                                <!-- input type="checkbox" :value="messageLine.selectedColor" v-model="selectedApplaytoAll" -->
                                <input
                                    :disabled="isCheckboxDisabled(index, messageLine.randID)"
                                    :checked="store.imprintStep.applyToAll.id !== null && store.imprintStep.applyToAll.randID !== messageLine.randID"
                                    type="checkbox"
                                    @input="applayToAllToogle(messageLine.id, messageLine.selectedColor, index, messageLine)"
                                >
                            </div>
                        </div>
                        <div class="clist-table__col clist-table__col--right-input" style="display: none">
                            <input
                                class="c-full-width new-imprint-input new-imprint-input--message"
                                type="text"

                                @change="setMessageForLine(index, $event.target.value)"
                            >
                        </div>
                    </li>
                </ul>
            </div>

          <div v-if="messageLine.selectedColor == 'cmyk'" class="cmyk-description">
            <b>Full {{getColorText()}}</b>
            <p> Your imprint will be completed in full {{getColorText(true)}}. A member of our team will contact you about
              your design after your order.</p>
          </div>
            <!--
                Check why here useing image type (c_color, index) in imprintColorsByLine[messageLine.id]
            -->
            <div class="choise-colors-pantone-wrapp" v-if="messageLine.isOpenedColorsPantoneWrapp">
                <div class="choise-colors-section">
                    <template v-if="imprintColorsByLine[messageLine.id]">
                        <template v-for="(c_color, imageColorIndex) in imprintColorsByLine[messageLine.id]._colors" :key="imageColorIndex">
                            <button
                                class="choise-colors-section__item"
                                style="width:25px; height: 25px"
                                :style="'background-image:url(' + colorCatalogBaseUrl + c_color.file_name + '.png)'"
                                @click="setColorForLine(index, c_color)"
                            >

                            </button>
                        </template>
                    </template>
                </div>
                <div class="text-or">
                    -OR-
                </div>
                <div class="applay-to-all">

                </div>
                <div class="pantone">
                    <template v-for="(customColor, colorIndex) in customColorList" :key="colorIndex">
                        <div class="custom-color-wrapp" @click="initCustomColorForLine(customColor, index)">
                            {{ customColor }}
                        </div>
                    </template>
                    <input
                        :id="'pantone-input-' + messageLine.id"
                        :ref="'pantone-input-' + messageLine.id"
                        class="pantone-input"
                        type="text"
                        placeholder="Enter PANTONE© name"
                    >

                    <div class="pantone-input-sub-wrapp">
                        <div class="pantone-input-sub__price">{{ '$' + customColourFee.toFixed(2) }}</div>
                        <div class="pantone-input-sub__link-wrapp">
                            <a
                                class="pantone-input-sub__link"
                                @click="pantoneSubmit(messageLine.id,'pantone-input-' + messageLine.id)"
                            >
                                submit
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </template>
    <!-- END Image Color Line Section -->
</div>
        <div class="start-new-imprint__section imprint-type--message_uploads">



        </div>

        <div class="start-new-imprint__section imprint-textarea">
            <label class="start-new-imprint__label" for="imprint-types">Special Instructions</label>
            <div id="imprint-types" class="start-new-imprint__textare">
                <textarea
                    class="c-full-width"
                    cols="30"
                    rows="10"
                    :value="specialInstruction"
                    @change="setSpecialInstruction($event.target.value)"
                >
                </textarea>
            </div>

            <div v-if="validation.hasError && activeImprintTypeID === validation.imprintType.id" class="error-section">
                <span class="error-message">
                    <template v-if="activeImprintTypeID === 1 && validation.imprintType.id === 1">
                        Please ensure each line has been filled out and has a colour selected before proceeding.
                    </template>
                    <template v-if="activeImprintTypeID === 2 && validation.imprintType.id === 2">
                         Please ensure that your image has been added and colour has been selected.
                    </template>
                    <template v-if="activeImprintTypeID === 3 && validation.imprintType.id === 3">
                        Please ensure each line has been filled out, an image has been selected and all colours have been chosen before proceeding.
                    </template>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { store } from './store.js'
import UploadImage from './UploadImage.vue';

export default {
    props: {
        validation: Object,
        getColorText: Function
    },
    components: {
        UploadImage
    },
    data() {
        return {
            imprintLocationSelected: '',
            debugMode: true,
            customColors: ['green', 'black', 'red', 'yellow'],
            selectedColors: [],
            selectedCustomColors: '',
            activeImprintTypeID: null,
            imprintTypes: [
                {
                    id: 1,
                    label: 'Text'
                },
                {
                    id: 2,
                    label: 'Image'
                },
                {
                    id: 3,
                    label: 'Text & Image'
                }

            ],
            applayToAll: {
                id: null, // TODO what mean id, maybe its not need
                selectedColor: null,
                lineIndex: null,
                randID: null
            },
            imprintMessageColorLines: [
                {
                    id: 0, //not sure if need, investigation and improvenment
                    randID: Date.now(),
                    label: 'Line',
                    selectedColor: null,
                    selectedColorObj: null,
                    custommColor: false,
                    isImageLine: false,
                    lineMessage: '',
                    colors: [],
                    isOpenedColorsPantoneWrapp: 0,
                    type: "message"
                }
            ],
            customColorList: [],
            selectColorBtn: {
                defaultBg: 'linear-gradient(135deg, #ffffff 0%, #ffffff 48%, #000000 50%, #ffffff 52%, #ffffff 100%);'
            },
            store: store,
            imprintData: {}, // configurable_2_data
            imprintSKU: '',
            imprintColorsByLine: {},
            imprintImageColorsByLine: {},
            colorCatalogBaseUrl: 'https://imprint-uploads.s3.ca-central-1.amazonaws.com/assets/images/imprint_app/colors/',
            maxCountLines: 5,
            customColourFee: 0,
            isImageLineInited: 0,
            specialInstruction: '',
            maxColors:0

        }
    },
    computed: {
        customBackground() {
            return this.$getCustomBackgroundColorClass(store.storeID);
        },
        customColor() {
            return this.$getCustomColorClass(store.storeID);
        },
    },
    methods: {

        isActiveAddLine() {
            return this.activeImprintTypeID == 1 && this.imprintMessageColorLines.length < (this.maxCountLines);
        },

        // TODO need improvements
        isRemoveBtnShow(activeImprintID, lineIndex, messageLine) {
            let hasImageLine = false;
            let hasRemoveBtn = false;
            let lineLength = this.imprintMessageColorLines.length;

            console.error("isRemoveBtnShow");
            this.imprintMessageColorLines.forEach(
                line => {
                    if(line.type === 'image') {
                        hasImageLine = true;
                    }
                }
            );

            if(activeImprintID === 1) {
                if(this.debugMode) {
                /*    console.error(activeImprintID);
                    console.warn(this.imprintMessageColorLines);
                    console.warn(hasImageLine);*/
                }
                if(hasImageLine && lineLength > 2) {
                    hasRemoveBtn = true;
                }
                if(!hasImageLine && lineLength > 1) {
                    hasRemoveBtn = true;
                }
                console.log("hasRemoveBtn");
                console.log(hasRemoveBtn);
            }
            if(activeImprintID === 3 && lineLength > 2) {
                hasRemoveBtn = true;
            }

            console.log("hasRemoveBtn 2");
            console.log(hasRemoveBtn);

            if(hasRemoveBtn && this.store.imprintStep.applyToAll.id === null) {
                hasRemoveBtn = true;

                console.log("hasRemoveBtn 3");
                console.log(hasRemoveBtn);
            } else {
                console.error("Remove Data>>>>");
                console.log(this.store.imprintStep.applyToAll);
                console.log(lineIndex);
                console.error(activeImprintID);
                console.warn(this.imprintMessageColorLines);
                console.warn(hasImageLine);
                if(this.store.imprintStep.applyToAll.randID === messageLine.randID)  {
                    hasRemoveBtn = false;
                    console.log("hasRemoveBtn 4");
                    console.log(hasRemoveBtn);
                } else if(this.store.imprintStep.applyToAll.randID !== null) {
                    hasRemoveBtn = true;
                    console.log("hasRemoveBtn 5");
                    console.log(hasRemoveBtn);
                    console.warn(messageLine.randID);
                    console.warn(this.store.imprintStep.applyToAll.randID);
                    console.warn(this.store.imprintStep.applyToAll.randID);
                }
               // this.imprintMessageColorLines.push(this.store.imprintMessageColorLines[this.store.imprintKey][this.store.imprintStep.applyToAll.id]);
            }

            return hasRemoveBtn;

        },
        initTab(id) {
            this.activeImprintTypeID = id;
            this.store.selectedLastStep[this.store.imprintKey].imprintTypeID = id;

            let result = 0;

            if(id > 1 ) {
                    let LineObj = {
                        id: this.imprintMessageColorLines.length,
                        randID: Date.now(),
                        label: 'Line',
                        selectedColor: this.applayToAll.selectedColor !== null ? this.applayToAll.selectedColor : null,
                        selectedColorObj: null,
                        custommColor: false,
                        lineMessage: '',
                        colors: [],
                        isOpenedColorsPantoneWrapp: 0,
                        type: "image"
                    }

                    this.isImageLineInited = this.imprintMessageColorLines.filter( item => { return item.type === 'image'}).length;

                  //  this.maxCountLines = 6;

                    if(!this.isImageLineInited) {
                        this.imprintMessageColorLines.push(LineObj);
                        this.store.imprintMessageColorLines[this.store.imprintKey] = this.imprintMessageColorLines;

                    }
            } else {
              //  this.maxCountLines = 5;
            }

            if(this.debugMode) {
                console.error("1111 imprintMessageColorLines");
                console.error(this.imprintMessageColorLines);
                console.error("2222 imprintTab id id id id ");
                console.error(id);
                console.warn(result);
            }
            this.$emit("stepFourChange", this.imprintMessageColorLines);
        },

        setSpecialInstruction(value) {
            this.store.selectedLastStep[this.store.imprintKey].special_instruction = value;
            this.specialInstruction = value;
            if(this.debugMode) {
                console.error("this.store.selectedLastStep[this.store.imprintKey].special_instruction");
                console.error(this.store.selectedLastStep[this.store.imprintKey].special_instruction);
            }
        },

        isCheckboxDisabled(index, randID = null) {
            let checkedNotCurrrent = this.store.imprintStep.applyToAll.randID !== randID && this.store.imprintStep.applyToAll.randID !== null;
            console.error("isCheckboxDisabled");
            console.log(this.applayToAll.index !== index && this.applayToAll.id !== null);
            console.log(this.imprintMessageColorLines.length === 0 || this.imprintMessageColorLines[index].selectedColor === null || checkedNotCurrrent);

            return this.imprintMessageColorLines.length === 0 || checkedNotCurrrent;
        },

        sortLineObjects() {
            let copiedImageLine = this.imprintMessageColorLines;
            this.imprintMessageColorLines = [];

            copiedImageLine.forEach(
                item => {
                    if(item.type === 'message') {
                        item.id = this.imprintMessageColorLines.length;
                        this.imprintMessageColorLines.push(item);
                    }
                }
            );

            copiedImageLine.forEach(
                item => {
                    if(item.type === 'image') {
                        item.id = this.imprintMessageColorLines.length;
                        this.imprintMessageColorLines.push(item);
                    }
                }
            );
        },


        uploadChanged(value) {
            this.$emit("stepFourChange", value);
        },

        addLineImprintMessage() {
            console.error("this.imprintMessageColorLines");
            console.error(this.imprintMessageColorLines);
            let countLines = this.imprintMessageColorLines.length;

            let LineObj = {
                id: countLines,
                randID: Date.now(),
                label: 'Line',
                selectedColor: this.applayToAll.selectedColor !== null ? this.applayToAll.selectedColor : null,
                selectedColorObj: null,
                custommColor: false,
                lineMessage: '',
                colors: [],
                isOpenedColorsPantoneWrapp: 0,
                type: "message"
            }

            console.warn("this.store.imprintStep");
            console.warn(this.store.imprintStep);
            console.warn(this.store.imprintStep.applyToAll.id);

            if(this.store.imprintStep.applyToAll.id === null) {
                this.imprintMessageColorLines.push(LineObj);
            } else {
                if(this.store.imprintStep.applyToAll.randID) {
                    let cloneImprintLine = { ...this.store.imprintStep.applyToAll['data'] };
                    cloneImprintLine.id = this.store.imprintMessageColorLines[this.store.imprintKey].length;
                    cloneImprintLine.randID = Date.now();
                    cloneImprintLine.lineMessage = '';

                    this.imprintMessageColorLines.push(cloneImprintLine);
                }
            }

            this.sortLineObjects();

            if(this.debugMode) {
                console.error("1111 imprintMessageColorLines");
                console.error(this.imprintMessageColorLines);
                console.warn(this.maxCountLines);
            }
            this.store.imprintMessageColorLines[this.store.imprintKey] = this.imprintMessageColorLines;
            this.$emit("stepFourChange", this.imprintMessageColorLines);
            console.error("add line");
            console.warn(this.store.imprintStep.applyToAll);
            console.warn(this.store.imprintStep.applyToAll.id);
            console.warn(this.store.imprintMessageColorLines[this.store.imprintKey]);
            console.warn(this.store.imprintMessageColorLines[this.store.imprintKey][this.store.imprintStep.applyToAll.id]);
            console.error(this.store.imprintMessageColorLines[this.store.imprintKey]);
            console.error(this.imprintMessageColorLines);
            console.error("this.store.imprintMessageColorLines");
            console.error(this.store.imprintMessageColorLines);

        },
        getLineIndexByRandID(randID) {
            this.store.imprintMessageColorLines[this.store.imprintKey].map(
                (item, index) => {
                    if(item.randID === randID) {
                        return index;
                    }
                }
            );
        },

        // lineid used as index
        colorsPantoneWrappToogle(lineId) {
            this.imprintMessageColorLines[lineId].isOpenedColorsPantoneWrapp = !this.imprintMessageColorLines[lineId].isOpenedColorsPantoneWrapp;
        },

        setMessageForLine(lineId, value) {
            this.imprintMessageColorLines[lineId].lineMessage = value;
            this.store.imprintMessageColorLines[this.store.imprintKey][lineId].lineMessage = value;
            this.$emit("stepFourChange", this.imprintMessageColorLines);
        },

        setImprintLocation(value, event) {
            console.error("!!!!!!!!!!!! setImprintLocation");
            // TODO this.store.selectedLastStep[this.store.imprintKey].imprintLocation change to this.store.selectedLastStep[this.store.imprintKey]._imprintLocation
            this.store.selectedLastStep[this.store.imprintKey].imprintLocation = value;
            this.store.selectedLastStep[this.store.imprintKey]._imprintLocation.value = value;
            this.store.selectedLastStep[this.store.imprintKey]._imprintLocation.sku = event.target.selectedOptions[0].dataset.sku;
            this.store.sku.imprint.location.val = event.target.selectedOptions[0].dataset.sku;

            this.imprintLocationSelected = value;
            if(this.debugMode) {
                console.log(this.store.selectedLastStep[this.store.imprintKey].imprintLocation);
                console.log(this.store.selectedLastStep[this.store.imprintKey]);
                console.log(event.target.dataSku);
                console.log(event.target.selectedOptions);
                console.log(event.target.selectedOptions[0].dataset.sku);
            }
        },

        // lineId used as index

        validateMaxColor(color) {
            let result = true;

            if (this.selectedColors.length > 0) {
                let colorsSkuSelected = [];
                this.selectedColors.forEach(
                    (item) => {
                        colorsSkuSelected.push(item.sku)
                    }
                );
                if (this.maxColors <= this.selectedColors.length && !colorsSkuSelected.includes(color.sku)) {
                    result = false;
                }
            }

            if (this.maxColors < 1) {
                result = false;
            }

            return result;
        },

        setColorForLine(lineId, color) {
            if(this.debugMode) {
                console.error("setColorForLine method");
                console.log(this.imprintMessageColorLines);
                console.log(lineId);
                console.log(this.imprintMessageColorLines[lineId]);
            }


            if(!this.validateMaxColor(color)){

                return false;
            }


            this.selectedColors.push(color);
            this.imprintMessageColorLines[lineId].selectedColor = color.file_name;
            this.imprintMessageColorLines[lineId].selectedColorObj = color;
            this.imprintMessageColorLines[lineId].custommColor = false;
            // store state
            this.store.imprintMessageColorLines[this.store.imprintKey][lineId].selectedColor = color.file_name;
            this.store.imprintMessageColorLines[this.store.imprintKey][lineId].selectedColorObj = color;
            // set custom Color to false for change different flow (custom string color & path to color preview)
            // can be moved to separate method for most undersurding
            this.store.imprintMessageColorLines[this.store.imprintKey][lineId].custommColor = false;

            if(this.debugMode) {
                console.error("setColorForLine");
                console.log(lineId);
                console.log(color);
                console.log(this.selectedColors);
                console.log(this.imprintMessageColorLines[lineId]);
                console.log(this.store.imprintMessageColorLines[this.store.imprintKey][lineId]);
                console.error("Set color prepeared properties sku >>>>>>>>>>>>");
                console.log(this.store.sku);
                console.log(this.store.properties);
            }

            if(this.applayToAll.id !== null) {
                this.applayToAll.selectedColor = null; // hotfix should be most understanding, emulate not seted applayToAll before
                this.applayToAllToogle(lineId, color.file_name, lineId);
            }

            this.colorsPantoneWrappToogle(lineId);
            this.$emit("stepFourChange", this.imprintMessageColorLines);

        },

        // Hot fix, need to change line id in code to index, after removing line if we set for last text line type message
        // we change color for image color need to fix and delete this method
        reindexImprintLinesID() {
            this.store.imprintMessageColorLines[this.store.imprintKey] = this.imprintMessageColorLines = this.imprintMessageColorLines.map(
                (element, index) => {
                    return element.id = index;
                }
            );

            this.$emit("stepFourChange", this.imprintMessageColorLines);
        },

        deleteLineImprintMessage(index, messageLine) {
            let colorIndex = this.selectedColors.indexOf(this.imprintMessageColorLines[index].selectedColor);
           // let colorStoreIndex = this.store.imprintMessageColorLines[this.store.imprintKey].indexOf(this.imprintMessageColorLines[index].selectedColor);

            if(colorIndex !== -1) {
                this.selectedColors.splice(colorIndex,1);
            }

            this.store.imprintMessageColorLines[this.store.imprintKey].filter(
                (el, i) => {
                    if(el.randID === messageLine.randID) {
                        console.error("Rang id store");
                        console.log(messageLine.randID);
                        console.log(el.randID);
                        console.log(i);
                        console.log(el);
                        console.warn(this.store.imprintMessageColorLines[this.store.imprintKey]);
                    }
                }
            );
            this.imprintMessageColorLines.filter(
                (item, itemIndex) => {
                    console.log(item);
                    console.log(itemIndex);
                    if(item.randID === messageLine.randID) {
                        console.error("Rang id hhhh");
                        console.log(messageLine.randID);
                        console.log(item.randID);
                        console.log(itemIndex);
                        console.log(item);
                        this.imprintMessageColorLines.splice(itemIndex,1);
                        this.store.imprintMessageColorLines[this.store.imprintKey] = this.imprintMessageColorLines;
                        this.$emit("stepFourChange", this.imprintMessageColorLines);
                    }
                }
            );

            console.warn("deleteLineImprintMessage");
            console.log(index);
            console.log(messageLine);
            console.log(this.imprintMessageColorLines);

           // this.reindexImprintLinesID();
            // TODO uncomment line after deleting call this.reindexImprintLinesID();
        },

        setDefaultActiveImprintTypeID(id = 1) {
            if(this.activeImprintTypeID === null) {
                /* Hardcoded set in 1 (first tab)*/
                this.activeImprintTypeID = id;
            }
        },

        initCurrentImprintData() {
            let linesData = null;

            this.imprintSKU = this.store.selectedImprint.sku;
            this.imprintData = this.store.inputProductData.fullJson.configurable_array[this.imprintSKU].configurable_2_data;
            this.customColourFee = this.imprintData.imprint_data.custom_colour_fee;

            // TODO remove after test weight value
            //this.store.properties.product_weight.val = this.imprintData.imprint_data.weight;
            //if (this.imprintData.simple_array[this.imprintSKU]) {
            //    this.store.properties.product_weight.val = this.imprintData.simple_array[this.imprintSKU].weight;
            //}

            // TODO: in Full Json we have some lines with title 'Image Color'
            // can be need use only with title 'Color'
            // as used for calculate maxCountMessageLines
            console.error(">>>>>>>>>>this.imprintColorsByLine");
            console.warn(this.store);
            console.warn(this.imprintData.imprint_data);
            console.error(">>>>>>>>>>END this.imprintColorsByLine");

            this.imprintColorsByLine = this.imprintData.imprint_options.filter(
                item => {
                    return item._custom_option_type == "drop_down";
                }
            );
            console.log(this.imprintColorsByLine);


            // Start calculate maxCountMessageLines
            linesData = this.imprintData.imprint_options.filter(
                item => {
                    return item._custom_option_title.includes('Line'); //&& item._custom_option_title == 'Color';
                }
            );


            console.log("linesData");
            console.log(linesData);
            this.maxCountLines = linesData.length;

            if(this.store.inputProductData.fullJson.configurable_array[this.imprintSKU]['max_color']) {
                this.maxColors = this.store.inputProductData.fullJson.configurable_array[this.imprintSKU]['max_color'];
            }else{
                console.log('max colors is empty');
            }

            if(this.debugMode) {
                console.error("initCurrentImprintData");
                console.log(this.imprintColorsByLine);
                console.log(this.imprintMessageColorLines);
                console.error('------------ this.maxCountLines');
                console.log(this.maxCountLines);
                console.error("prepeared properties sku >>>>>>>>>>>>");
                console.log(this.store.sku);
                console.log(this.store.properties);
            }
        },

        // TODO hard to understending input data, check and improve
        // `id` and `index` after testing are equil

        /****
         * data: object
            id: null,
            selectedColor: null,
            index: null,
        */
        setApplayToAllDataInStore(data) {
            this.store.imprintStep.applyToAll = data;
        },
        applayToAllToogle(id, selectedColor, index, imprintLineData) {
            console.error("!!!! clicked apply to all checkbox >>>>: ");
            console.warn(imprintLineData);

            let isCustomColor = this.imprintMessageColorLines[index].custommColor;

            if(this.applayToAll.randID == null) {
                this.applayToAll['data'] = imprintLineData;
                this.applayToAll.id = id;
                this.applayToAll['randID'] = imprintLineData.randID;
                this.applayToAll.selectedColor = selectedColor;
                this.applayToAll.index = index; // TODO we have inited in data 'lineIndex' but use 'index', need to fix
                this.imprintMessageColorLines[index]['isApplyToAllElement'] = true;
                this.setApplayToAllColor(selectedColor, id, isCustomColor, imprintLineData);

            } else {
                this.applayToAll['data'] = null;
                this.applayToAll.randID = null;
                this.store.imprintStep.applyToAll.randID = null;
                this.applayToAll.id = null;
                this.applayToAll.selectedColor = null;
                this.applayToAll.index = null;
                this.imprintMessageColorLines[index]['isApplyToAllElement'] = false;
                this.setApplayToAllColor(null, id, isCustomColor, imprintLineData);
            }

            this.setApplayToAllDataInStore(this.applayToAll);

            if(this.debugMode) {
                console.error("applayToAllToogle");
                console.log(selectedColor);
                console.log(id);
                console.log(this.imprintMessageColorLines);
                console.log(isCustomColor);
                console.log(this.applayToAll);
            }
            //this.$emit("stepFourChange", this.imprintMessageColorLines);
        },

        setApplayToAllColor(selectedColor, excludeId, isCustomColor, lineData) {
            console.error(" >>>>> Set Apply to All Color Before start the loop");
            console.warn(this.imprintMessageColorLines);
            console.warn(selectedColor);
            console.log(excludeId);
            console.log(isCustomColor);
            this.imprintMessageColorLines.forEach(
                (item, index) => {
                    if(item.id !== excludeId) {
                        // TODO changed current component data what about global store
                        if(isCustomColor) {
                            this.imprintMessageColorLines[index].selectedColor = selectedColor;
                            this.imprintMessageColorLines[index].custommColor = true;
                            this.imprintMessageColorLines[index].selectedColorObj = lineData.selectedColorObj;
                        } else {
                            this.imprintMessageColorLines[index].selectedColor = selectedColor;
                            this.imprintMessageColorLines[index].custommColor = false;
                            this.imprintMessageColorLines[index].selectedColorObj = lineData.selectedColorObj;
                        }
                    }
                }
            );
            console.error(" >>>>> Set Apply to All Color After the loop");
            console.warn(this.imprintMessageColorLines);

            this.$emit("stepFourChange", this.imprintMessageColorLines);
        },
        // create list of custom colors (Pantone color)
        pantoneSubmit(lineId, ref) {
            if(this.$refs['pantone-input-' + lineId][0]['value'].length) {
                let value = this.$refs['pantone-input-' +  + lineId ][0]['value'];

                if(!this.customColorList.includes(value)) {
                    this.customColorList.push(value);
                    this.initCustomColorForLine(value, lineId);
                }

                this.$refs['pantone-input-' +  + lineId][0]['value'] = '';
            }
            if(this.debugMode) {
                console.warn("111111111++++ pantoneSubmit +++++11111111");
                console.warn(lineId);
                console.warn(ref);
                console.warn(typeof ref);
                console.warn(this.$refs);
                console.warn(this.$refs['pantone-input-' +  + lineId ][0]['value']);
                console.warn(this.$refs[ref].value);
            }
        },

        // change state global and current when user add the custom color (Pantone color)
        initCustomColorForLine(customColorText, lineId) {
            console.error("initCustomColorForLine");
            console.warn(this.applayToAll);

            this.imprintMessageColorLines[lineId].selectedColor = customColorText;
            this.imprintMessageColorLines[lineId].custommColor = true;
            this.store.imprintMessageColorLines[this.store.imprintKey][lineId].selectedColor = customColorText;
            this.store.imprintMessageColorLines[this.store.imprintKey][lineId].custommColor = true;

            // check if checkbox Applay to All checked
            // this.applayToAll.id can be equil `0`
            if(this.applayToAll.id !== null) {
                this.applayToAll.selectedColor = null; // hotfix should be most understanding, emulate not seted applayToAll before
                let imprintMessageLineData = this.store.imprintMessageColorLines[lineId] ? this.store.imprintMessageColorLines[lineId] : null;
                this.applayToAllToogle(lineId, customColorText, lineId, imprintMessageLineData);
            }

            console.error(this.imprintMessageColorLines);
            console.error(this.store.imprintMessageColorLines[this.store.imprintKey]);
            this.colorsPantoneWrappToogle(lineId);
            this.$emit("stepFourChange", this.imprintMessageColorLines);
        },
        initDataFromStore() {
            let dataFromStore = {
                hasColor: false,
                imprintLocation: this.store.selectedLastStep[this.store.imprintKey].imprintLocation
            };

            if(this.store.imprintMessageColorLines[this.store.imprintKey].length) {
                this.store.imprintMessageColorLines[this.store.imprintKey].forEach(
                    line => {
                        if(line.selectedColor) {
                            dataFromStore.hasColor = true;
                        }
                    }
                );
            }
            console.warn(dataFromStore);

            return dataFromStore;
        },
        sortLocationItems() {
            this.imprintData.imprint_position._imprints.sort((a,b)=>{
                return a.sort - b.sort;
            });

            this.imprintLocationSelected = !this.store.selectedLastStep[this.store.imprintKey].imprintLocation
                                    ? this.imprintData.imprint_position._imprints[0].title
                                    : this.store.selectedLastStep[this.store.imprintKey].imprintLocation;

            if(this.imprintLocationSelected.length && !this.store.selectedLastStep[this.store.imprintKey].imprintLocation.length) {
                this.store.selectedLastStep[this.store.imprintKey].imprintLocation = this.imprintLocationSelected;
            }
            //this.imprintLocationSelected = this.imprintData.imprint_position._imprints[0].title;
            console.error("@@@@@@@@@@@@@@@@@ >>>>>> this.imprintData.imprint_position._imprints");
            console.log(this.imprintData.imprint_position._imprints);
        },
    },

    created() {
        console.error("Created NewImprintCard");
        console.log(this.imprintMessageColorLines);
        console.log(this.store.imprintMessageColorLines[this.store.imprintKey]);
        console.log(this.store);

        /* If data was set in store init local variable*/
        let dataFromStore = this.initDataFromStore();

        if(
            dataFromStore.hasColor
        ) {
            console.warn("imprint data reinited from store");
            this.imprintMessageColorLines = this.store.imprintMessageColorLines[this.store.imprintKey];
        }

        this.setDefaultActiveImprintTypeID(this.store.selectedLastStep[this.store.imprintKey].imprintTypeID);
        this.initTab(this.store.selectedLastStep[this.store.imprintKey].imprintTypeID);


        if(this.debugMode) {
            console.error("first step imprint type");
            console.error(this.store.selectedImprint.sku);
        }

        this.initCurrentImprintData();

        this.specialInstruction = this.store.selectedLastStep[this.store.imprintKey].special_instruction ? this.store.selectedLastStep[this.store.imprintKey].special_instruction : '';

        this.sortLocationItems();
        this.$emit("stepFourChange", this.imprintMessageColorLines);
    }
}

</script>

<style>

.error-section {
    display: inline-block;
    width: 100%;
    position: relative;
    padding: 5px;
    color: black;
    background: rgba(255, 0, 0, 0.5);
    border: 1px solid red;
    line-height: 15px;
}

.error-section .error-message {
    font-family: "museo-sans", sans-serif;
    font-size: 10px;
    font-weight: 300;
}

.custom-color-wrapp {
    padding: 3px;
    font-size: 12px;
}

.custom-color-wrapp:hover {
    border: 1px solid #0054a3;
}

.pantone-input-sub__price {
    font-size: 10px;
    color: rgb(90, 90, 90);
    font-family: 'Montserrat', 'Helvetica Neue', Verdana, Arial, sans-serif; /*from magento mapleleaf*/
}
.pantone-input-sub__link, .pantone-input-sub__link:hover {
    text-decoration: underline;
    font-style: italic;
    font-size: 12px;
    cursor: pointer;
    color: rgb(90, 90, 90);
}
.pantone-input-sub-wrapp {
    display: flex;
    justify-content: space-between;
}

.pantone-input {
    margin-bottom: 0!important;
    max-height: 30px!important;
    min-height: 30px!important;
    height: 30px!important;
}

.clist-table__col--double {
    display: flex;
    justify-content: space-between;
}

.choise-colors-section {
    max-width: 210px;
}
.choise-colors-pantone-wrapp {
    padding-top: 25px;
    display: flex;
    justify-content: space-between;
}
.choise-colors-section .choise-colors-section__item {
    margin: 0px 10px 10px 0px;
    border: 1px solid #767676;
}

.clist-table li {
    margin-bottom: 3px;
}

.clist-table {
    width: 100%;
}

.clist-table .clist-table__row.clist-table__row--two-cols .clist-table__col:nth-child(1) {
   width: 40%;
}
.clist-table .clist-table__row.clist-table__row--two-cols .clist-table__col:nth-child(2) {
   width: 60%;
}
.clist-table__col--right-input input.new-imprint-input {
    margin-bottom: 0;
    max-height: 30px;
    min-height: 30px;
    height: 30px;
}

.clist-table__col--title {
    padding-bottom: 5px;
    font-weight: 300;
    font-size: 14px;
    color: rgb(90, 90, 90);
}
.clist-table__col--title-double {
    display: flex;
    justify-content: space-between;
    padding-right: 20px;
}
.selected_color_wrapper {
    padding: 2px;
    border: 1px solid #c1c1c1;
    width: 50px;
    position: relative;
    height: 30px;
}

.selected_color_wrapper:after {
    content: ">";
    color: #000000;
    position: absolute;
    top: 3px;
    right: 6px;
}

.selected_color_wrapper.selected_color_wrapper--large {
    width: 45%;
}

.selected_color_wrapper.selected_color_wrapper--large .selected_color {
    width: auto;
    padding-left: 4px;
}

.selected_color {
    width:24px;
    height: 24px;
    border: 1px solid #c1c1c1;
}
/*
.start-new-imprint__label-imprint-types {
    margin-bottom: 0;
    max-height: 30px;
    min-height: 30px;
    height: 30px;
}*/
.image-color-text{
  width: 50px;
  font-size: 13px;
  font-weight: 300;
  line-height: 1.5;
}
.start-new-imprint__section.imprint-type--message .imprint-message__add{
  max-width: 170px;
}

.choise-colors-section .choise-colors-section__item,
.selected_color_wrapper .selected_color
{
  background-position: center;
}

.cmyk-description{
  max-width: 200px;
  font-size: 10px;
  font-family: 'museo-sans', sans-serif;
  line-height: 15px;
}

.selected_color_wrapper .selected_color.custom {
    overflow-x: auto;
    border: none;
    width: 75%;
    white-space: nowrap;
}

@media only screen and (max-width: 768px) {
    .text-or{
        min-width: 45px;
    }
}

@media screen and (max-width: 450px) {
    .choise-colors-section {
        max-width: 150px;
    }

    .selected_color_wrapper .selected_color.custom {
        width: 65%;
    }
}

</style>